// extracted by mini-css-extract-plugin
module.exports = {"addinItem":"welcome_addinItem__3y3I-","titleText":"welcome_titleText__10TFH","button":"welcome_button__gNKln","container":"welcome_container__15hoT"};